import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import { whisperItems } from '@/mocks/home';

export default function WhisperStream() {
  return (
    <section id="whispers" className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            index="03"
            title="线人风声"
            subtitle="一句一句地听，先记住时间与地点；代号可以保留，身份线索不进页面。"
          />
        </Reveal>

        <div className="relative mt-10 pl-6 md:pl-8">
          <span className="absolute left-[5px] top-2 bottom-2 w-px bg-background-200 md:left-[7px]" />
          <div className="flex flex-col gap-8">
            {whisperItems.map((item, index) => (
              <Reveal key={item.id} delay={index * 90}>
                <div className="relative">
                  <span className="absolute -left-6 top-1.5 flex h-3 w-3 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50 md:-left-8" />
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-medium text-primary-700">
                      代号「{item.code}」
                    </span>
                    <span className="font-label text-xs text-foreground-500">{item.time}</span>
                    <span className="font-label text-xs text-foreground-500">{item.region}</span>
                  </div>
                  <p className="mt-3 font-heading text-lg leading-relaxed text-foreground-900 md:text-xl">
                    {item.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal>
          <div className="mt-10 flex flex-col gap-3 rounded-lg border border-dashed border-background-300 bg-background-100/60 p-5 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-body text-sm text-foreground-700">
              风声只提供线索，不给出结论。想追踪某条，可先蹲下期预告。
            </p>
            <a
              href="#next"
              className="inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              回到预告区
              <i className="ri-arrow-up-line text-base" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}